import { Helmet } from 'react-helmet-async';

export const Appcast = () => {
  return (
    <Helmet>
      {/* Appcast.io Conversions */}
      <script type="text/javascript" src="https://click.appcast.io/pixels/generic3-26807.js?ent=196" />
    </Helmet>
  );
};

export default Appcast;